import {OpenCategory} from './OpenCategory';
import {HideWord} from "./HideWord";
import {NextWord} from "./NextWord"
import {SaveTranslate} from "./SaveTranslate";
import {ChangeTranslate} from "./ChangeTranslate";
import {ShowChangedCells} from "./ShowChangedCells";
import {ConfirmTranslate} from "./ConfirmTranslate";


export const ButtonFunctions = [ChangeTranslate, OpenCategory, NextWord, HideWord,  ShowChangedCells, SaveTranslate, ConfirmTranslate];

